import { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import {
  RequestGatewayPlugin,
  ResponseGatewayPlugin,
  ResponseErrorGatewayPlugin,
  RequestErrorGatewayPlugin,
  RequestOptions,
} from "../type";

class Gateway {
  private requestPlugins: RequestGatewayPlugin[] = [];

  private requestErrorPlugins: RequestErrorGatewayPlugin[] = [];

  private responsePlugins: ResponseGatewayPlugin[] = [];

  private responseErrorPlugins: ResponseErrorGatewayPlugin[] = [];

  use(
    plugin:
      | RequestGatewayPlugin
      | ResponseGatewayPlugin
      | ResponseErrorGatewayPlugin
      | RequestErrorGatewayPlugin,
  ) {
    if (plugin.type === "request") {
      this.requestPlugins.push(plugin);
    } else if (plugin.type === "response") {
      this.responsePlugins.push(plugin);
    } else if (plugin.type === "responseError") {
      this.responseErrorPlugins.push(plugin);
    }
  }

  applyRequestAll(
    config: InternalAxiosRequestConfig,
    options: RequestOptions,
    urls?: string[],
  ): InternalAxiosRequestConfig {
    this.requestPlugins.forEach((plugin) => {
      config = plugin.apply(config, options, urls);
    });
    return config;
  }

  applyResponseAll(
    res: AxiosResponse,
    options: RequestOptions,
    urls?: string[],
  ): AxiosResponse {
    this.responsePlugins.forEach((plugin) => {
      res = plugin.apply(res, options, urls);
    });
    return res;
  }

  applyRequestErrorAll(
    error: AxiosError,
    options: RequestOptions,
    urls?: string[],
  ): AxiosError {
    this.requestErrorPlugins.forEach((plugin) => {
      error = plugin.apply(error, options, urls);
    });
    return error;
  }

  applyResponseErrorAll(
    error: AxiosError,
    options: RequestOptions,
    urls?: string[],
  ): AxiosError {
    this.responseErrorPlugins.forEach((plugin) => {
      error = plugin.apply(error, options, urls);
    });
    return error;
  }
}

export default Gateway;
